import { LoadableAfterPaint } from '@confluence/loadable';

export const BannerContainer = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-BannerContainer" */ './BannerContainer'))
			.BannerContainer,
});
